import React from 'react';
import Slider from '@material-ui/core/Slider';
import { ControlLabel } from 'react-bootstrap';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import InformationBlock from "../InformationBlock";

function SimpleSliderField({ label, subLabel, value, min, max, onChange, disabled }) {
  const muiTheme = createMuiTheme({
    overrides:{
      MuiSlider: {
        track: {
          color: 'black'
        },
        rail: {
          color: 'black'
        },
        thumb: {
          backgroundColor: (value < 20) ? 'yellow' : '#03ff28',
          color: '#1fa1ff'
        },
        valueLabel: {
          color: (value < 20) ? '#ebeb0e' : '#03ff28',
        }
      }
    }
  });

  return (
    <div className="simple-slider">
      <ControlLabel>
        {label}
      </ControlLabel>
      <ThemeProvider theme={muiTheme}>
        <Slider
          value={value.toFixed(1)}
          onChange={onChange}
          aria-labelledby="continuous-slider"
          valueLabelDisplay="on"
          min={min}
          max={max}
          disabled={disabled}
        />
      </ThemeProvider>
      {disabled && (
        <div className="sub-label error">Something doesn’t seem quite right. Adjust your values and try again.</div>
      )}
      {subLabel && (
        <div className="sub-label">{subLabel}</div>
      )}
      {(value !== 0 && value < 20) ? (
        <InformationBlock
          text="If you do not put down 20%, you will have to pay private mortgage insurance (PMI) which typically costs about 1% of the amount borrowed every year. On a mortgage of $200,000, for example, PMI would be about $167/month (1% of $200,000 / 12)."
        />
      ): null}
    </div>
  )
}

export default SimpleSliderField;



// WEBPACK FOOTER //
// ./src/components/SimpleSliderField/index.js